export const TASKS_TABLE_COLUMNS = 8
export const TASK_EXECUTORS_MAX = 10
